import styled from 'styled-components'
import { Title as DefaultTitle, Row as DefaultRow } from '~components'
import { SubmitButton } from '~components'

export const Button = styled(SubmitButton)`
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin: 0;
    width: 100%;
  }
`

export const Title = styled(DefaultTitle)`
  margin-bottom: ${({ theme }) => theme.spacing.km2};
`

export const Row = styled(DefaultRow)`
  margin-left: 96px;
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    flex-direction: column;
    margin-left: 0;
  }
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: auto;
    position: initial;
    left: unset;
    transform: unset;
    align-items: unset;
  }
`

export const Footer = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    position: fixed;
    background: white;
    bottom: 0;
    width: 100%;
    left: 0;
    padding: ${({ theme }) => theme.spacing.km0} ${({ theme }) => theme.spacing.km4}
      ${({ theme }) => theme.spacing.km6} ${({ theme }) => theme.spacing.km4};
    outline: ${({ theme }) => theme.border.width.thinner}
      ${({ theme }) => theme.border.style.solid}
      ${({ theme }) => theme.neutral.background.default};
  }
`
